export default class RespostaPergunta {
    returnModel() {
        return {
            id: null,
            pais: null,
            resposta: null,
            pergunta: null,
            listaValoresAtributo: null,
            indicadorMultiplaEscolhaListaValoresAtributo: null,
            descricao: null
        }
    }
}